exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-padding[data-v-321eb31e]{max-height:600px;min-height:320px;padding:20px}.add-opt-value[data-v-321eb31e]{display:inline-block;color:#555;background:#ddd;padding:8px 16px;font-size:.86rem;border-radius:3px;cursor:pointer}", ""]);

// exports
